import React, { useState } from 'react';

function NameForm({ onAddPerson }) {
  const [name, setName] = useState("");
  const [beers, setBeers] = useState(1); // Default to 1

  const handleSubmit = (e) => {
    e.preventDefault();
    const beersCount = parseInt(beers, 10);
    if (name.trim() !== "" && !isNaN(beersCount)) {
      onAddPerson({ name, beers: beersCount });
      setName("");
      setBeers(1);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input 
        type="text" 
        placeholder="Enter name" 
        value={name} 
        onChange={(e) => setName(e.target.value)} 
      />
      <input 
        type="number" 
        min="1"
        value={beers} 
        onChange={(e) => setBeers(e.target.value)} 
      />
      <button type="submit">Add Person</button>
    </form>
  );
}

export default NameForm;
